import {Injectable} from '@angular/core';
import {isUndefined} from 'util';

@Injectable()
export class PasswordService {

  private minPasswordLength: number;

  constructor() {
    this.minPasswordLength = 5;
  }

  /*
   * Returns empty string if password correct, or error message if password incorrect
   */
  checkPassword(password: string): string {
    if (isUndefined(password)) {
      return "Введите пароль";
    }
    console.log("Password is ", password);
    if (password.length < this.minPasswordLength) {
      return "Длина пароля должна быть не меньше " + this.minPasswordLength
        + " символов!";
    }
    const regexContainsNumbers = /[0-9]/;
    if (!regexContainsNumbers.test(password)) {
      return "Пароль должен содержать буквы латинского алфавита и цифры";
    }
    const regexContainsRussianLetters = /[а-яА-Я]/;
    if (regexContainsRussianLetters.test(password)) {
      return "Пароль не должен содержать русские буквы";
    }
    const regexContainsLetters = /[a-zA-Z]/;
    if (!regexContainsLetters.test(password)) {
      return "Пароль должен содержать буквы латинского алфавита и цифры";
    }
    const regexContainsSpace = / /;
    if (regexContainsSpace.test(password)) {
      return "Пароль не может содержать пробел";
    }
    const regexContainsForbiddenSymbols = /\W+/;
    if (regexContainsForbiddenSymbols.test(password)) {
      const forbiddenSymbols = regexContainsForbiddenSymbols.exec(password)[0];
      return "Пароль не может содержать следующие символы/символ: \""
        + forbiddenSymbols + '"';
    }
    return "";
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/password.service.ts